<template>
  <div class="contact">
    <header-info activeName="/contact"></header-info>
    <div class="detail">
      <section class="img">
        <el-button class="login" @click="goLogin">立即登录</el-button>
      </section>
      <section class="introduce">
        <div class="up">
          <div class="team">
            <div class="teamdown">
              <span class="title">腾景AI经济预测</span>运用近年来快速发展的机器学习特别是深度学习等人工智能前沿技术，与实时化、动态化的投入产出体系深度融合，在一系列关键技术攻关的基础上，对重要的经济金融指标进行高频模拟和预测，形成了在国内外具有开拓性、领先性、实用性的产品体系。
            </div>
          </div>
          <div class="upimg">
            <img src="@/assets/img/introduce/macro05.png" alt />
          </div>
        </div>
      </section>
      <section class="what">
        <p class="titlerow">是什么？</p>
        <p class="uprow">宏观高频模拟和预测库包括“总量”“价格”“金融”领域共29个指标，是目前国家有关部门发布的反映宏观经济运行最常用也是最重要的指标。</p>
        <div class="downrow">
          <div class="box-card">
            <div class="whatimg">
              <img src="@/assets/img/introduce/macro03.png" alt />
            </div>
            <div class="coretitle">高频模拟</div>
            <div
              class="coreinfo"
            >所谓高频模拟，就是在搜集加工大量相关数据的基础上，依托经典机器学习和深度学习模型，把月度指标日度化，使通常一个多月后才公布的指标，当日或近日就能呈现出来，比如，月初的CPI指标，过去要到一个半月后才公布，有了高频模拟，当日就知晓了。</div>
          </div>
          <div class="box-card">
            <div class="whatimg">
              <img src="@/assets/img/introduce/macro04.png" alt />
            </div>
            <div class="coretitle">预测</div>
            <div
              class="coreinfo predict"
            >所谓预测，就是运用深度学习的前沿算法，重点在海量数据中搜寻非线性相关关系，发现并提炼那些过去、当下和未来都会起作用的规律性因素，从而实现对某一变量未来一定时期的预测。</div>
          </div>
        </div>
        <div class="cardInfo">
          <el-card class="box-card">
            <div class="coreinfo">
              每个指标都包括三个部分，第一部分是历史走势，第二部分是最新走势的高频模拟，第三部分是对未来一段时间走势的预测。高频模拟是日度更新，预测依据指标特性周度或月度更新。对每个指标，
              既可以看到最新状态，也能看到未来一定时间（目前是9-12个月）的走势。正所谓
              <span
                class="empsis"
              >近看当日，远观全年，腾景预测，一目了然。</span>
            </div>
          </el-card>
        </div>
      </section>
      <section class="character">
        <p class="titlerow">特点</p>
        <div class="box-item">
          <div class="box-card">
            <div class="coreimg">
              <img src="@/assets/img/introduce/icon01.png" alt />
            </div>
            <div class="coretitle">快</div>
            <div class="coreinfo">前两天经济活动发生的变化，今天的指标上就能看到。准确地讲，已经实际发生但官方统计机构尚未发布的经济指标走势信息率先得到</div>
          </div>
          <div class="box-card">
            <div class="coreimg">
              <img src="@/assets/img/introduce/icon02.png" alt />
            </div>
            <div class="coretitle">远</div>
            <div class="coreinfo">未来一段时间（目前是9-12月）的走势能够大体把握</div>
          </div>
          <div class="box-card">
            <div class="coreimg">
              <img src="@/assets/img/introduce/icon03.png" alt />
            </div>
            <div class="coretitle">全</div>
            <div class="coreinfo">不是少数几个指标，反映宏观经济和金融活动走势的重要指标都包括在内</div>
          </div>
          <div class="box-card">
            <div class="coreimg">
              <img src="@/assets/img/introduce/icon04.png" alt />
            </div>
            <div class="coretitle">动</div>
            <div class="coreinfo">所有指标都是动态更新和迭代，高频模拟是日度更新，预测是周期或月度更新</div>
          </div>
          <div class="box-card">
            <div class="coreimg">
              <img src="@/assets/img/introduce/icon05.png" alt />
            </div>
            <div class="coretitle">潮</div>
            <div class="coreinfo">运用数字技术，展示方式别具一格，直观、绚丽、便捷，一屏观天下、知冷暖、看未来</div>
          </div>
          <div class="box-card">
            <div class="coreimg">
              <img src="@/assets/img/introduce/icon06.png" alt />
            </div>
            <div class="coretitle">准</div>
            <div class="coreinfo">方向和数值准确率平均在70%左右，部分指标可以达到80-90%以上</div>
          </div>
        </div>
      </section>
      <section class="provide">
        <div class="boxin">
          <p class="titlerow">与众不同：我们提供了什么</p>
          <!-- <p class='titlerow'>
            "
          </p>-->
          <div class="word">
            <p>每一个关注和思考中国经济形势的朋友，每天实际上都在回顾过去、总结规律，看着当下、做着高频模拟，尤其是想着未来、进行着预测，只是形式不同而已。数字时代，每天各种各样的信息和说法潮水般涌来，有高见，亦不乏忽悠和杂音，一天下来，有时候不是更清醒，而是更糊涂了。大家所期待的，是脑海中所萦绕的那条连接历史、当下和未来的曲线能够更清晰、更有道理。我们的产品就是要满足大家的需求，给各位提供分析经济走势的干货。</p>
            <p>有朋友会问:你们的产品有什么过人之处，真的与众不同吗？这里就需要了解深度学习技术的特点和优势，还要有正确的预测观。与传统的计量经济模型等相比，深度学习技术运用特定算法，在强大算力加持下，在数十万、数百万乃致更多海量数据中寻找线性特别是非线性相关关系，这在传统预测方法中是不可想象的，因而在预测时间长度、精度和范围上，形成了若干个数量级的优势。</p>
            <p>当然，未来总是有不确定性的，人类社会不可能完全消除这种不确定性。反过来说，如果未来什么事情都能预测，这个世界也就无趣了。另一方面，总是有一些从过去、到现在、再到未来一直起作用，我们称之为“规律性”的因素，把握住这些因素，未来在很大程度上是有迹可循的。从这个意义上说，预测并不是一件神秘的事情，只是发掘那些未来仍会起作用的历史信息。</p>
            <p>也正是由于这个原因，我们多数情况下是预测某个指标的平滑值，因为平滑值含有更多的历史信息。预测时主要关注两个方面，一是走向，向上、向下还是平行；二是拐点，顶部的拐点或底部的拐点。对大多数指标来说，一年中最重要、最困难的是把握住一两个、两三个大的拐点，如果预测能够帮助解决这个问题，应该说足以令人满意了。</p>
            <p>我们期待的是，如果说您在脑海中实际上进行的高频模拟和预测准确率是60%，借助我们的产品，准确率能够提升到70%-80%乃至更高一些，通俗地说，您的成绩从60分提高到70分、80分或更高一些，从而为您的经济形势分析和具体业务活动带来实实在在的帮助。</p>
          </div>
        </div>
      </section>
      <section class="pro-data">
        <div class="titlerow">我们提供的数据</div>
        <div class="up">
          <div class="index-content">
            <el-tabs v-model="activeIndex" @tab-click="handleClick">
              <el-tab-pane
                :label="tab.indexName"
                :name="tab.id"
                v-for="tab in rightTabs"
                :key="tab.id"
              ></el-tab-pane>
            </el-tabs>
            <el-tabs
              style="margin-top:18px"
              v-model="secondActiveIndex"
              @tab-click="handleSecondClick"
            >
              <el-tab-pane
                :label="tab.indexName"
                :name="tab.id"
                v-for="tab in secondTab"
                :key="tab.id"
              ></el-tab-pane>
            </el-tabs>
            <div class="chart-wrap" v-if="indexLines.length">
              <div
                class="chart-item"
                :style="{width:(100/lineSize)+'%'}"
                v-for="line in indexLines"
                :key="line.id"
              >
                <div class="chart">
                  <div class="title">{{line.indexName}}</div>
                  <div class="line-chart" @click="goLogin">
                    <line-chart :noShadow="noShadow" :indexId="line.id" :indexName="line.indexName"></line-chart>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <footer-info></footer-info>
  </div>
</template>

<script>
import headerInfo from "@/pages/layout/introHeader.vue";
import footerInfo from "@/pages/layout/footer.vue";
import { findIndexStructure } from "@/api/product";
import mixin from "@/utils/mixins.js";
import lineChart from "@/pages/product//lineChart.vue";
export default {
  mixins: [mixin],
  components: {
    headerInfo,
    footerInfo,
    lineChart
  },
  data() {
    return {
      active: "5",
      activeIndex: "", // 右侧tab
      rightTabs: [],
      indexLines: [],
      secondActiveIndex: "",
      secondTab: [],
      lineSize: 4,
      noShadow: false
    };
  },
  created() {
    this.handleFindIndexStructure();
  },
  methods: {
    async handleFindIndexStructure() {
      let { data } = await findIndexStructure({
        systemId: this.active
      });
      this.rightTabs = data.resultBody;
      if (this.rightTabs) {
        this.activeIndex = this.rightTabs[0].id;
        this.indexLines = this.rightTabs[0].indexList;
        this.lineSize = this.rightTabs[0].lineSize;
      }
    },
    handleClick(val) {
      this.indexLines = [];
      this.secondTab = [];
      let arr = this.rightTabs.filter(i => i.id == val.name);
      // 存在二级
      if (arr[0].nextList) {
        this.secondTab = arr[0].nextList;
        // 默认激活
        this.secondActiveIndex = this.secondTab[0].id;
        this.indexLines = arr[0].nextList[0].indexList;
      } else {
        this.secondTab = [];
        this.indexLines = arr[0].indexList;
      }
      this.lineSize = arr[0].lineSize;
    },
    handleSecondClick(val) {
      this.indexLines = [];
      let arr = this.secondTab.filter(i => i.id == val.name);
      this.indexLines = arr[0].indexList;
    },
    goLogin() {
      this.goMacro1("macro");
    }
  }
};
</script>

<style lang="scss" scoped>
.contact {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .detail {
    flex: 1;
    .img {
      height: 700px;
      background: url("../../assets/img/introduce/macro01.png") no-repeat;
      text-align: center;
      .login {
        background-color: #fff;
        border-color: #fff;
        border-radius: 30px;
        color: #4f0188;
        width: 200px;
        height: 60px;
        margin-top: 500px;
        font-size: 24px;
        font-weight: 500;
      }
    }
    .titlerow {
      color: #1c2d86;
      font-size: 30px;
      font-weight: 600;
      text-align: center;
      margin-bottom: 100px;
    }
    .introduce {
      height: 450px;
      padding: 80px 500px 0;
      .up {
        display: flex;
        .upimg {
          flex: 1;
          height: 220px;
          background-color: #1f2531;
          margin-left: 50px;
        }
        .team {
          flex: 1;
          margin-top: 100px;
          .teamdown {
            line-height: 30px;
            .title {
              font-size: 20px;
              font-weight: 600;
              margin-bottom: 50px;
            }
          }
        }
      }
    }
    .what {
      height: 930px;
      padding: 50px 450px;
      background-color: #f3f3f3;
      color: #5f5f5f;
      // display: flex;
      .uprow {
        padding: 0 160px 30px;
        line-height: 30px;
        font-weight: 500;
      }
      .downrow {
        display: flex;
        justify-content: space-between;
        padding-top: 20px;
        .box-card {
          .coretitle {
            color: #292929;
            font-size: 22px;
            font-weight: 700;
            text-align: left;
            margin: 30px 20px 20px;
          }
          .coreinfo {
            font-size: 18px;
            color: #5f5f5f;
            padding: 0 90px 0 20px;
            line-height: 30px;
          }
          .predict {
            padding: 0 20px;
          }
        }
      }
      .cardInfo {
        margin-top: 80px;
        .box-card {
          padding: 30px 150px 60px;
          .coreinfo {
            font-size: 18px;
            color: #5f5f5f;
            line-height: 30px;
            .empsis {
              font-weight: 700;
            }
          }
        }
      }
    }
    .character {
      margin-top: 80px;
      height: 850px;
      padding: 100px 450px 80px;
      .box-item {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .box-card {
          width: 26%;
          margin: 20px;
          display: flex;
          flex-direction: column;
          align-items: center;
          .coretitle {
            font-size: 24px;
            font-weight: 600;
            margin: 20px;
          }
          .coreinfo {
            line-height: 30px;
            color: #5f5f5f;
            font-weight: 500;
            padding: 0 20px;
          }
        }
      }
    }
    .provide {
      background-color: #f3f3f3;
      padding: 50px 100px;
      .boxin {
        background-color: #fff;
        padding: 20px 100px 50px;
        .word {
          padding: 0 400px;
          p {
            font-size: 18px;
            color: #5f5f5f;
            line-height: 30px;
            margin-bottom: 40px;
            font-size: 500;
          }
        }
      }
    }
    .pro-data {
      padding: 80px 450px;
      .titlerow {
        margin-bottom: 50px;
      }
      .up {
        .index-content {
          margin: 20px 0 0 20px;
          padding: 20px;
          background: #fff;
          border-radius: 10px;
          .chart-wrap {
            display: flex;
            flex-wrap: wrap;
            .chart-item {
              padding: 10px;
              box-sizing: border-box;
              .chart {
                border: 1px solid #c9c9c9;
                height: 190px;
                padding: 10px;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                .line-chart {
                  flex: 1;
                }
              }
            }
          }
          /deep/ .el-tabs__item {
            padding-left: 0 !important;
            padding-right: 50px;
            height: 42px !important;
            font-size: 18px;
          }
          /deep/ .el-tabs__item:hover {
            color: #2c58ff;
          }
          /deep/ .el-tabs__item.is-active {
            color: #2c58ff;
            font-weight: 500;
          }
          /deep/ .el-tabs__active-bar {
            background-color: #2c58ff;
            height: 3px;
          }
          /deep/ .el-tabs__nav-wrap::after {
            height: 0;
          }
        }
      }
    }
  }
}
</style>